import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClassService } from '../../../../../services/class.service';
import { StudentService } from '../../../../../services/student.service';
import { SystemService } from '../../../../../services/system.service';
import { UserType } from '../../../../../model/Const';


@Component({
    selector: 'app-manage-index',
    templateUrl: './manage.component.html',
    styleUrls: ['./manage.component.scss'],
    standalone: false
})
export class StudentsManageIndexComponent implements OnInit {
  displayData: any[] = [];
  totalNum = 0;
  currentPageIndex = 1;
  classId = 0;
  className = '';
  classComment = '';
  errStudentDataVisible = false;
  errStus: any[] = [];
  showBatchAddBtn = false;

  disabledButton = true;
  allChecked = false;
  indeterminate = false;
  checkedNumber = 0;

  classChangeVisible = false;
  isLoadingTeacherCLass = false;

  teacherList: any[] = [];
  classList: any[] = [];
  teacherCache = {};
  classCache = {};

  selectedTeacher = null;
  selectedClass = null;
  adjustReportData = false;
  confirmChangeVisible = false;
  schoolMaster = false;
  returnPage = 1;

  deleteStudentConfirm = false;

  delStudentId = 0;

  changeClassText = '';
  teacher = '';
  private userInfo: any;
  // @ts-ignore
  private allListPage: boolean;
  loadingData = false;


  constructor(private userService: UserService,
              private stuService: StudentService,
              private clsService: ClassService,
              private activatedRoute: ActivatedRoute ,
              private router: Router ,
              private sysSrv: SystemService,
              private nzMessageService: NzMessageService) {
    this.userInfo = this.userService.getUserInfo();
    this.schoolMaster = this.userInfo.type === UserType.SCHOOL_ADMIN;
    this.activatedRoute.params.subscribe( params => {
      if (params['class_id'] && parseInt(params['class_id'], 10) === params['class_id'] * 1) {
        this.classId = parseInt(params['class_id'], 10);
      }
    });
    this.activatedRoute.queryParams.subscribe( query => {
      if (query['page'] && parseInt(query['page'], 10) === query['page'] * 1) {
        this.returnPage = parseInt(query['page'], 10);
      }
    });
  }

  ngOnInit() {
    this.loadData(this.currentPageIndex);
    // this.loadClassData();
  }
  loadData(page: string|number) {
    this.loadingData = true;
    this.stuService.fetchStudentsBySchoolId(page).then(students => {

      this.displayData = students.rows;
      this.totalNum = students.total;
      // this.className = students.class_name;
      // this.classComment = students.class_comment;
      // @ts-ignore
      this.currentPageIndex = page;
      this.refreshStatus();

      this.setTmpNumId();
      this.loadingData = false;
    }).catch(err => {
      this.nzMessageService.error(`error: ${err.message}`);
    });
  }
  setTmpNumId() {
    for (let i = 0; i < this.displayData.length; i++) {
      // @ts-ignore
      this.displayData[i].numId = i + 1 + (this.currentPageIndex - 1) * 10;
    }
  }
  loadClassData() {
    const srv = this.clsService;
    this.clsService.fetchClassAndTeacher(this.classId).then(data => {
      this.className = data[0].class_name;
      this.teacher = data[0].teacher;
    });
  }
  closeDeleteStudentConfirm() {
    this.delStudentId = 0;
    this.deleteStudentConfirm = false;
  }
  sureDeleteStudentConfirm() {

    if (!this.delStudentId) {
      return;
    }
    this.userService.unbindClassStudent(this.classId, this.delStudentId).then(classes => {
      this.loadData(this.currentPageIndex);
      // this.currentPageIndex = 1;
      this.deleteStudentConfirm = false;
    }).catch(e => {
      this.deleteStudentConfirm = false;
      this.nzMessageService.error(e.message);
    });
    this.delStudentId = 0;
  }
  deleteStudentReConfirm(id: any) {
    this.delStudentId = id;
    this.deleteStudentConfirm = true;
  }
  deleteStudents() {
    // @ts-ignore
    const ids = this.displayData.filter(value => value.checked).map( u => u.id);
    this.userService.removeStudents(this.classId, ids).then(classes => {
      this.loadData(this.currentPageIndex);
      // this.currentPageIndex = 1;
    });
  }
  editStudent(id: any) {
    this.router.navigate([`/admin/classes/${this.classId}/students/edit/${id}`]);
  }
  batchAddStudents = (file: File) => {
    const data = new FormData();
    data.append('file', file);
    this.userService.batchAddUsers(this.classId , data).then(r => {
      console.log(r);
      this.errStus = r;
      this.errStudentDataVisible = true;
    });
    return false;
  }
  handleErrStuCancel() {
    this.loadData(1);
    this.errStudentDataVisible = false;
  }
  handleErrStuOk()  {
    this.loadData(1);
    this.errStudentDataVisible = false;
  }
  checkAll(value: boolean): void {
    // @ts-ignore
    this.displayData.forEach(data => data.checked = value);
    this.refreshStatus();
  }
  refreshStatus(): void {
    // @ts-ignore
    const allChecked = this.displayData.every((value: any) => value.checked === true);
    // @ts-ignore
    const allUnChecked = this.displayData.every((value: any) => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
    // @ts-ignore
    this.disabledButton = !this.displayData.some((value: any) => value.checked);
    // @ts-ignore
    this.checkedNumber = this.displayData.filter((value: any) => value.checked).length;
  }
  changeStudentClass() {
    if (this.checkedNumber > 0) {
      if (Object.keys(this.teacherCache).length && Object.keys(this.classCache).length) {
        this.classChangeVisible = true;
        return;
      }
      this.isLoadingTeacherCLass = true;
      const info = this.userService.getUserInfo();
      this.sysSrv.loadTeacherAndClasses(info.school_id).then(result => {
        this.classChangeVisible = true;

        console.log('result:', result);
// @ts-ignore
        this.teacherCache[info.school_id] = result.teachers;
        for (const k of Object.keys(result.teachers)) {
          const t = result.teachers[k];
          // @ts-ignore
          if (this.classCache[t.teacher_id]) {
            // @ts-ignore
            this.classCache[t.teacher_id] = [...this.classCache[t.teacher_id], ...result.classes[t.teacher_id]];
          } else {
            // @ts-ignore
            this.classCache[t.teacher_id] = result.classes[t.teacher_id] ? result.classes[t.teacher_id] : [] ;
          }
        }
        this.teacherList = Object.values(result.teachers);

        this.isLoadingTeacherCLass = false;
      });
    }
  }
  closeChangeStudentClass() {
    this.classChangeVisible = false;
    this.isLoadingTeacherCLass = false;
    this.adjustReportData = false;
  }
  doSelectTeacher(teacher: any) {
    this.selectedTeacher = teacher;
    this.classList = [];
    this.selectedClass = null;
    // @ts-ignore
    if (this.classCache[teacher.teacher_id]) {
      // @ts-ignore
      this.classList = this.classCache[teacher.teacher_id] as any;
    } else {
      alert('no classes for this teacher');
    }
  }
  setChangeClassText() {
      let str = '将 ';
      let len = 0;
      for (let i = 0; i <  this.displayData.length; i++) {
        // @ts-ignore
          if (this.displayData[i].checked) {
              len ++ ;
            // @ts-ignore
              str += (this.displayData[i].name || this.displayData[i].user_name) + ' 、';
          }
      }
      str = str.substr(0, str.length - 1);
    // @ts-ignore
      str += `移动到 ${this.selectedTeacher.name} 老师的 ${this.selectedClass.name} 吗？`;
      this.changeClassText = str;
  }
  handleChangeOk() {
    this.confirmChangeVisible = true;
    this.setChangeClassText();
  }
  closeConfirm() {
    this.confirmChangeVisible = false;
  }
  sureConfirm() {
    console.log('in sureConfirm');
    // @ts-ignore
    const uids = this.displayData.filter(value => value.checked).map(r => r.id);
    console.log(this.selectedClass);
    console.log(uids);
    // @ts-ignore
    this.stuService.changeClass(this.selectedClass.id, uids, this.adjustReportData).then(r => {
      this.loadData(this.currentPageIndex);
      this.confirmChangeVisible = false;
      this.classChangeVisible = false;

    }).catch(e => {
      this.nzMessageService.error(e.message);
    });
  }






  goClassStudentsList(class_id: any) {
    // this.router.navigate([`/admin/classes/edit/${class_id}`], { queryParams: {page: this.currentPageIndex}});
    this.router.navigate([`/admin/classes/${class_id}/students/index`], { queryParams: {page: this.currentPageIndex}});
  }
}
